import { postMessageToNative } from "~/lib/webview";
import { isNativeApplication } from "./platform";

export type ReproEventProps = Record<string, string | number | boolean>;

/**
 * Repro イベントを送信する。通常は `trackEvent()` 経由で呼び出すこと。
 *
 * - ネイティブアプリ: postMessage(REPRO_TRACK) 経由でブリッジ送信
 * - source が指定された場合、全体集計用イベントに加えて導線別イベントも送信する
 *   例: source='profile' → 'COMPLETE_SEND_MESSAGE' + 'COMPLETE_SEND_MESSAGE_profile'
 */
export const trackReproEvent = (
  eventName: string,
  props?: ReproEventProps,
  source?: string,
): void => {
  if (!isNativeApplication()) return;

  setTimeout(() => {
    try {
      postMessageToNative({
        type: "REPRO_TRACK",
        payload: { event: eventName, props: props ?? {} },
      });

      if (source) {
        postMessageToNative({
          type: "REPRO_TRACK",
          payload: { event: `${eventName}_${source}`, props: props ?? {} },
        });
      }
    } catch {
      // 補助機能のため例外は握りつぶす
    }
  }, 0);
};
